import { render, staticRenderFns } from "./ProductoPrecioForm.vue?vue&type=template&id=bd5116b8&scoped=true"
import script from "./ProductoPrecioForm.vue?vue&type=script&lang=js"
export * from "./ProductoPrecioForm.vue?vue&type=script&lang=js"
import style0 from "./ProductoPrecioForm.vue?vue&type=style&index=0&id=bd5116b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5116b8",
  null
  
)

export default component.exports